import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find-index";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";
import _keysInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/keys";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import logger from "../../../util/logger";
import * as _ from "../../../util/lodash";
import React from 'react';
import { Table as UITable } from 'semantic-ui-react';
import { Utils } from "../../../wayin-react";
import { selectionTypes } from "../../../enums";
/**
 * selects a range of rows indexes
 * @param    {array}  allIndexes       array of all indexes
 * @param    {array}  selectedIndexes  array of selected indexes
 * @param    {number} targetIndex     index of clicked row
 * @return   {array}  returns array of selected indexes from a range of rows
 */
//this code is copied over from coreapp

var selectRange = function selectRange(_ref) {
  var allIndexes = _ref.allIndexes,
      selectedIndexes = _ref.selectedIndexes,
      targetIndex = _ref.targetIndex;
  // getting first and last indexes of selected rows from array of all indexes
  var firstSelectedIndex = selectedIndexes[0] ? _findIndexInstanceProperty(_).call(_, allIndexes, function (id) {
    return id === selectedIndexes[0];
  }) : 0;
  var lastSelectedIndex = _.last(selectedIndexes) ? _findIndexInstanceProperty(_).call(_, allIndexes, function (id) {
    return id === _.last(selectedIndexes);
  }) : 0; // getting the clicked row index

  var targetRowIndex = _findIndexInstanceProperty(_).call(_, allIndexes, function (id) {
    return id === targetIndex;
  }); // getting rows indexes which are contiguous (no rows in between)


  var isContiguous = _sliceInstanceProperty(_).call(_, allIndexes, firstSelectedIndex, lastSelectedIndex + 1).length === selectedIndexes.length; // making and returning an array of a selection of a range of indexes

  if (_.isEmpty(selectedIndexes)) {
    return _.take(allIndexes, targetRowIndex + 1); // case when clicked row index is smaller then first selected row index
  } else if (targetRowIndex <= firstSelectedIndex) {
    return _sliceInstanceProperty(_).call(_, allIndexes, targetRowIndex, firstSelectedIndex + 1); // case when clicked row index is bigger then last selected row index
  } else if (targetRowIndex > lastSelectedIndex) {
    return _concatInstanceProperty(_).call(_, selectedIndexes, _sliceInstanceProperty(_).call(_, allIndexes, lastSelectedIndex + 1, targetRowIndex + 1)); // case when first and last selected rows are contiguous and clicked row index is one of them
  } else if (isContiguous && targetRowIndex >= firstSelectedIndex && targetRowIndex <= lastSelectedIndex) {
    return _sliceInstanceProperty(_).call(_, allIndexes, firstSelectedIndex, targetRowIndex + 1); // case when first and last selected rows are not contiguous and clicked row index is in between fist and last ones
  } else if (!isContiguous && targetRowIndex >= firstSelectedIndex && targetRowIndex <= lastSelectedIndex) {
    return _sliceInstanceProperty(_).call(_, allIndexes, targetRowIndex, lastSelectedIndex + 1);
  }
};
/**
 * toggle row selection
 * @param  {array}  selectedIndexes  array of selected indexes
 * @param  {number} targetIndex     index of clicked row
 * @return {array}  returns array of selected indexes after toggling
 */


var toggleSelect = function toggleSelect(_ref2) {
  var selectedIndexes = _ref2.selectedIndexes,
      targetIndex = _ref2.targetIndex;
  return _includesInstanceProperty(_).call(_, selectedIndexes, targetIndex) ? _.without(selectedIndexes, targetIndex) : _concatInstanceProperty(_).call(_, selectedIndexes, targetIndex);
};
/**
 * Extract Table header/footer/body props and rows from the passed in children.
 * * @returns {object} - containing { tableHeaderProps, tableBodyProps, tableFooterProps, rows }
 */


export var getTableProps = function getTableProps(children) {
  return _reduceInstanceProperty(_).call(_, React.Children.toArray(children), function (acc, child) {
    //iteratee
    if (Utils.isType(UITable.Header, child)) {
      acc.tableHeaderProps = child.props;
    } else if (Utils.isType(UITable.Footer, child)) {
      acc.tableFooterProps = child.props;
    } else if (Utils.isType(UITable.Body, child)) {
      var _acc$rows;

      acc.tableBodyProps = _.without(child.props, 'children');

      (_acc$rows = acc.rows).push.apply(_acc$rows, React.Children.toArray(child.props.children));
    } else if (Utils.isType(UITable.Row, child)) {
      acc.rows.push(child);
    }

    return acc;
  }, {
    //accumulator
    rows: []
  });
};
/**
 * Calculates the new selection of rows, using previously selected indexes, selection type and mouse event
 * @param {MouseEvent} e - mouse event
 * @param {string} selectionType - row selection type
 * @param {array} selectedIndexes - list of selected row indexes
 * @param {number} targetIndex - row index being clicked
 * @param {number} rowsLength - total number of rows
 * @return {array} of newly selected row indexes
 */

export var getNewSelection = function getNewSelection(e, selectionType, selectedIndexes, targetIndex, rowsLength) {
  var newSelection = []; //based on selectionType, select/unselect single or multiple rows

  switch (selectionType) {
    case selectionTypes.SINGLE:
      newSelection = targetIndex === selectedIndexes[0] ? [
        /* deselecting */
      ] : [targetIndex];
      break;

    case selectionTypes.MULTIPLE:
      if (e.shiftKey) {
        var _context;

        var allIndexes = _Array$from(_keysInstanceProperty(_context = Array(rowsLength)).call(_context)); // creates an array with values, starting from 0 up until the given index [0, 1, 2, 3, 4, 5, ..., index]


        newSelection = selectRange({
          allIndexes: allIndexes,
          selectedIndexes: selectedIndexes,
          targetIndex: targetIndex
        });
      } else if (e.metaKey || e.ctrlKey) {
        newSelection = toggleSelect({
          selectedIndexes: selectedIndexes,
          targetIndex: targetIndex
        });
      } else {
        newSelection = targetIndex === selectedIndexes[0] ? [
          /* deselecting */
        ] : [targetIndex];
      }

      break;

    case selectionTypes.NONE:
      break;
  }

  return _sortInstanceProperty(newSelection).call(newSelection);
};
/**
 * log props related warnings
 */

export var showWarnings = function showWarnings(p) {
  //scroll is not supported while the Table is transparent, as the scrollable body would show up under the fixed table headwer/footer. Show up a warning.
  logger.warn('Table scroll will not work, when `allowScroll: true` and `isTransparent: true`. Choose one or the other.', p.allowScroll && p.isTransparent); //onSelection is required when selectionType SINGLE or MULTIPLE is being used

  logger.warn('`onSelection` is required when selectionType: selectionTypes.SINGLE or selectionTypes.MULTIPLE is used. Make sure you pass in the `onSelection` function.', !p.onSelection && (p.selectionType === selectionTypes.SINGLE || p.selectionType === selectionTypes.MULTIPLE));
  logger.warn('`selectedRows` will not work with selectionType: selectionTypes.NONE, use it with selectionTypes.SINGLE or selectionTypes.MULTIPLE', p.selectedRows && p.selectedRows.length > 0 && p.selectionType === selectionTypes.NONE);
  logger.warn('only using the first value from `selectedRows` when selectionType: selectionTypes.SINGLE is set', p.selectedRows && p.selectedRows.length > 1 && p.selectionType === selectionTypes.SINGLE);
};
/**
 * Goes through the list of selectedRowValues, checks them against the provided rowValues and returns the row index, where the selected row value appears.
 */

export var rowValuesToIndexes = function rowValuesToIndexes(selectionType, selectedRowValues, rowValues) {
  switch (selectionType) {
    case selectionTypes.NONE:
      return [];
    //should NOT return any value

    case selectionTypes.SINGLE:
      return [_findIndexInstanceProperty(_).call(_, rowValues, function (rowValue) {
        return rowValue == selectedRowValues[0];
      })];
    //in case the dev has provided more values: search up the first value only.

    case selectionTypes.MULTIPLE:
      return _mapInstanceProperty(_).call(_, selectedRowValues, function (value) {
        return _findIndexInstanceProperty(_).call(_, rowValues, function (rowValue) {
          return rowValue == value;
        });
      });
    //look up the indexes for all row values
  }
};
//# sourceMappingURL=utils.js.map